<template>
<div>
    <div class="selectTypeBox">
        <el-radio-group v-model="selectType" @change="onChangeSelectType">
            <el-radio-button label="未申请"></el-radio-button>
            <el-radio-button label="已申请"></el-radio-button>
            <el-radio-button label="发放中"></el-radio-button>
            <el-radio-button label="发放完毕"></el-radio-button>
        </el-radio-group>
    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">
            <div class="leftDiv">
                <P>{{item.userName}}，{{item.phone}}，成单时角色:{{ingRole[item.role]}}</P>
                <p>
                    奖品名称：{{item.prize}}
                </p>
                <p v-if="item.receiverName">
                    收件人信息：收件人姓名：{{item.receiverName}}  收件人地址：{{item.receiverAdder}}  收件人电话：{{item.receiverPhone}}
                </p>
                <p v-if="item.courierNumber">
                    快递单号：{{item.courierNumber}}
                </p>
                
            </div>
            <div class="rightDiv">
                <div>
                    <el-button v-if="Number(item.status) === 1" @click="set1(item)">标记奖品已发中</el-button>
                    <el-button v-if="Number(item.status) === 2" @click="set2(item)">标记奖品已发放</el-button>
                </div>
            </div>
        </div>
    </div>
    <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
    </div>
    <el-dialog title="提示" :visible.sync="shsbInfoStatus1" width="30%" center>
        <p style="padding:10px 0">是否将该条目设置为发放中</p>
        <el-input placeholder="请输入快递单号" v-model="setCode"> </el-input>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="shsbInfoStatus1 = false">取 消</el-button>
            <el-button type="primary" @click="qr1()">确 定</el-button>
        </span>
    </el-dialog>
        <el-dialog title="提示" :visible.sync="shsbInfoStatus2" width="30%" center>
        <p style="padding:10px 0">是否将该条目设置为已发奖</p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="shsbInfoStatus1 = false">取 消</el-button>
            <el-button type="primary" @click="qr2()">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'zjList',
    props: {},
    data() {
        return {
            setCode: '',
            shsbInfoStatus1: false,
            shsbInfoStatus2: false,
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            id: '',
            dialogVisible: false,
            setid: '',
            setItem: {},
            setPdfUrl: '',
            setnum: '',
            ingRole: {
                "1": '猎头',
                "3": '自荐人',
                "4": '候选人'
            },
            selectType: '未申请',
            selectTypeArray: {
                "未申请": 0,
                "已申请": 1,
                "发放中": 2,
                "发放完毕": 3
            },
            monthlyPay: 0,
            moneyReward: 0,
            entryDate: '',
            commissionMethod: false,
            homeAmount: 0,
            warrantyAmount: 0,
            jobInfo: {

            },
            tdrInfo: {},
            tdrInfoStatus: false,
            reasShBox: false,
            shsbInfoStatus: false,
            setShsbItem: {
                sbyyInfo: ''
            }
        }
    },
    watch: {

    },
    methods: {
        getPositionLost: function () {
            debugger
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/lottery/getlotterDrawResultList',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    pageSize: this.pageSize,
                    pageNumber: this.pageNumber,
                    status: this.selectTypeArray[this.selectType]
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },

        qr1 () {
            let that = this
            if (this.setCode === '') {
                    that.$message({
                        message: '快递单号不能为空',
                        type: 'warning'
                    });
                return false
            }
            let data = {courierNumber: this.setCode,
                    id: this.setItem.id}
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/lottery/signStatus',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.shsbInfoStatus1 = false
                    that.setCode = ''
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },

        qr2 () {
            let that = this
            let data = {
                    id: this.setItem.id}
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/lottery/signStatusyesGrant',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.shsbInfoStatus2 = false
                    that.setCode = ''
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },

        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        onChangeSelectType(e) {
            this.pageSize = 20
            this.pageNumber = 1
            this.selectType = e
            this.getPositionLost()
        },
        set1 (item) {
            this.setItem = item
            this. shsbInfoStatus1 = true
        },
        set2 (item) {
            this.setItem = item
            this. shsbInfoStatus2 = true
        },
    },
    mounted: function () {
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 150px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
}

.itemList .itemDiv .leftDiv div {
    padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv .active {
    color: red;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}

.demo-input-suffix>p {
    padding: 10px 0;
}

.reasShBox {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}

.reasShBox>div {
    width: 50vw;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
}

.reasShBox>div>iframe {
    width: 100%;
    height: 100%;
}

.reasShBox>div:nth-child(1) {
    background-color: #ffffff;
    padding: 30px;
    box-sizing: border-box;
}

.reasShBox>div .title {
    padding: 10px 0;
    width: max-content;
    background-color: #cecece;
}

.reasShBox>div .cont {
    padding: 10px;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
}

.reasShBox .buttonBox {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>
